import defaultsDeep from 'lodash/defaultsDeep';
import themeOptionsBase from '../themeOptionsBase';
import breakpoints from './breakpoints';
import * as components from './components';
import palette from './palette';
import shadows from './shadows';
import transitions from './transitions';
import typography from './typography';

/**
 * This is a theme based on Banner Atria
 * https://bhdgwebdesignsa.z22.web.core.windows.net/index.html
 * https://www.figma.com/board/Sf5JtqnKHV1tdVIGDO7DHe/Digital-Forms-Scrum-Team?node-id=99-18317&t=Pj85YKRbUteqxjed-0
 */
const themeOptionsVariant2 = defaultsDeep({
  breakpoints,
  components,
  palette,
  shadows,
  transitions,
  typography
}, themeOptionsBase);
export default themeOptionsVariant2;